import { liveBind } from 'evite'

// -------------------------------------------------------
// --------------------- Side menu -----------------------
// -------------------------------------------------------

if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector;
if (!Element.prototype.closest) Element.prototype.closest = function (selector) {
    let el = this;
    while (el) {
        if (el.matches(selector)) {
            return el;
        }
        el = el.parentElement;
    }
};

class MenuSlide {
    static create(){
        let el = document.querySelector('#side_menu');
        let header = document.querySelector('#header');
        if(el && header){
          return new MenuSlide({ el, header, });
        }
        return null;
    }

    constructor(options = {}) {
        this.el = evite.assertInstanceOf(options.el, HTMLElement);
        this.header = evite.assertInstanceOf(options.header, HTMLElement);

        evite.when('jquery', 'block footer').then(() => {
            this.bindEvents();
            Array.from(document.querySelectorAll('.accordion-nav')).forEach(el => new NavAccordionToggle({el:el}));
        });
    }

    bindEvents() {
        liveBind(this.el, 'click', '.register-signin', this.closeMenu);
        liveBind(this.el, 'click', '.content-mask', this.closeMenuPreventDefault);
        liveBind(this.el, 'click', '.details .summary', this.toggleDetails);
        liveBind(this.header, 'click', '.menu-button.button-nav', this.toggleMenu);

        liveBind(document.body, 'click', '.create-invitation-button', this.toggleMenu);
        liveBind(document.body, 'click', '.browse-gallery-button-top', this.toggleMenu);
        liveBind(document.body, 'click', '.browse-gallery-button-bottom', this.toggleMenu);
        liveBind(document.body, 'click', '.browse-occasions-button', this.toggleMenu);
        liveBind(document.body, 'swipeleft', '#side_menu', this.closeMenu);

        const mask = document.querySelector('.content-mask');
        if (mask) {
            mask.addEventListener('click', this.closeMenu);
            mask.addEventListener('swipeleft', this.closeMenu);
        }
    };

    toggleDetails = (event) => {
        event.preventDefault();
        let details = event.target.parentNode;
        if (details) {
            details.setAttribute('aria-expanded', details.getAttribute('aria-expanded') !== 'true');
        }
        return false;
    };

    toggleMenu = () => {
        this.isActive?
          this.closeMenu():
          this.openMenu();
    };

    openMenu = () => {
        this.el.classList.add('side-menu-active');
        $('body').addClass('side-menu-active');
    };

    closeMenu = () => {
        this.el.classList.remove('side-menu-active');
        $('body').removeClass('side-menu-active');
    };

    closeMenuPreventDefault = (event) => {
        event.preventDefault();
        this.closeMenu();
    };

    get isActive(){
        return this.el.classList.contains('side-menu-active');
    }

    get details() {
        return this.el.querySelector('.details');
    };

    get summary() {
        return this.el.querySelector('.summary');
    };
}

class NavAccordionToggle {
    constructor(options) {
        this.el = options.el;
        this.el.addEventListener('click', this.toggleAccordion);
    }

    toggleAccordion = (event) => {
        event.preventDefault();
        const header = event.target.closest('.accordion-nav');
        const currentActive = document.querySelector('.ui-accordion:not(.collapsed)');

        if (header.parentNode.classList.contains('collapsed')) {
            currentActive.querySelector('ul');
            currentActive.querySelectorAll('.accordion-nav').forEach(el => el.classList.add('inactive'));
            currentActive.classList.add('collapsed');
        }
        header.parentNode.querySelector('ul');
        header.parentNode.classList.remove('collapsed');
        header.classList.remove('inactive');
    };
}

export default MenuSlide;



// WEBPACK FOOTER //
// ./assets/es6/common/side_menu.es6